import { render, staticRenderFns } from "./thingsAdmin.vue?vue&type=template&id=3f837908&"
import script from "./thingsAdmin.vue?vue&type=script&lang=js&"
export * from "./thingsAdmin.vue?vue&type=script&lang=js&"
import style0 from "./thingsAdmin.vue?vue&type=style&index=0&id=3f837908&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports